import { z } from "zod";

export const contactNurseFormSchema = z.object({
  orderId: z
    .number({
      required_error: "Order-Id is required.",
      invalid_type_error: "Order-Id must be a number.",
    }) 
    .refine((val) => val > 0, {
      message: "Order-Id must be a positive number",
    }),
     

  message: z
    .string()
    .trim()
    .nonempty("Message is required.")
    .min(10, "Message must be at least 10 characters")
    .max(700, "Message must be less than 700 characters")
    .trim()
    .refine((val) => val.length > 0, {
      message: "Message cannot be only spaces",
    }),
});

export type ContactNurseFormSchema = z.infer<typeof contactNurseFormSchema>;
